import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export function ZyAnimatorVersionConversionDialog({
    showVersionConversionModal,
    setShowVersionConversionModal,
    onStartConversion,
    isStarting,
}: {
    showVersionConversionModal: boolean;
    setShowVersionConversionModal: (showVersionConversionModal: boolean) => void;
    onStartConversion: () => void;
    isStarting?: boolean;
}) {
    return (
        <Dialog
            open={showVersionConversionModal}
            onOpenChange={open => {
                if (!isStarting) {
                    setShowVersionConversionModal(open);
                }
            }}
        >
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Convert animation to V2</DialogTitle>
                    <DialogDescription>
                        The animation will open in the V2 builder for editing. A separate popup shows the original V1 animation as a
                        reference. Accept when you are satisfied, or Cancel to discard all changes.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        variant="outline"
                        disabled={isStarting}
                        onClick={() => setShowVersionConversionModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={isStarting}
                        onClick={onStartConversion}
                    >
                        {isStarting ? 'Starting…' : 'Convert'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
